// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bgf_a","ReactCrop--disabled":"bgf_b","ReactCrop--circular-crop":"bgf_c"};